import { render } from "./JobDetailsPanel.vue?vue&type=template&id=57d5fa24&scoped=true"
import script from "./JobDetailsPanel.vue?vue&type=script&lang=js"
export * from "./JobDetailsPanel.vue?vue&type=script&lang=js"

import "./JobDetailsPanel.vue?vue&type=style&index=0&id=57d5fa24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57d5fa24"]])

export default __exports__